var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.75,
    y: 47.25,
    width: 40.5,
    height: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52,13.5A36,36,0,1,0,77.46,24,35.9,35.9,0,0,0,52,13.5ZM74.28,71.77a31.5,31.5,0,1,1,0-44.55A31.32,31.32,0,0,1,74.28,71.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRemove);
export default __webpack_public_path__ + "static/media/CircleRemove.81cd612ec6dde499d2d8f02226b1259b.svg";
export { ForwardRef as ReactComponent };